import {
  actionTypes,
  certificationRequestSuccess,
  certificationRequestFailure,
  keepItemsRequestSuccess,
  keepItemsRequestFailure,
  revokeItemsRequestSuccess,
  revokeItemsRequestFailure,
  validateItemsRequestSuccess,
  validateItemsRequestFailure,
  editRevisorRequestSuccess,
  editRevisorRequestFailure,
  editCampaignRequestSuccess,
  editCampaignRequestFailure,
  closeCertificationSuccess,
  closeCertificationFailure,
  closeCertificationItemSuccess,
  closeCertificationItemFailure,
  sendCertificationReminderSuccess,
  sendCertificationReminderFailure,
  updateRevisorSuccess,
  updateRevisorFailure,
  reOpenItemSuccess,
  reOpenItemFailure,
  editPerimeterGroupsPerimeterRequestSuccess,
  editPerimeterGroupsPerimeterRequestFailure,
  supervisorsRequestCertificationReferenceSuccess,
  supervisorsRequestCertificationReferenceFailure,
  editPerimeterOwnershipEntitlementsPerimeterRequestSuccess,
  editPerimeterOwnershipEntitlementsPerimeterRequestFailure,
  editPerimeterBrPerimeterRequestSuccess,
  editPerimeterBrPerimeterRequestFailure,
  editPerimeterApplicationsPerimeterRequestFailure,
  editPerimeterApplicationsPerimeterRequestSuccess,
  editPerimeterUsersPerimeterRequestSuccess,
  editPerimeterUsersPerimeterRequestFailure,
  getUserTabListActionSuccess,
  getUserTabListActionFailure,
  getOUTabListActionSuccess,
  getOUTabListActionFailure,
  getBRTabListActionSuccess,
  getBRTabListActionFailure,
  getEntitlementTabListActionSuccess,
  getEntitlementTabListActionFailure,
  getAccountTabListActionSuccess,
  getAccountTabListActionFailure,
  getEntitlementsGivenUserActionFailure,
  getEntitlementsGivenUserActionSuccess,
  getUsersGivenEntitlementActionFailure,
  getUsersGivenEntitlementActionSuccess,
  getEntitlementsGivenOuActionSuccess,
  getEntitlementsGivenOuActionFailure,
  getEntitlementsGivenBrActionSuccess,
  getEntitlementsGivenBrActionFailure,
  getAccountsGivenUserActionSuccess,
  getAccountsGivenUserActionFailure,
  massiveOperationsItemsRequestFailure,
  massiveOperationsItemsRequestSuccess,
  updateAggregateOuRevisorRequestSuccess,
  updateAggregateOuRevisorRequestFailure,
  updateAggregateUserRevisorRequestSuccess,
  updateAggregateUserRevisorRequestFailure,
  updateAggregateBrEntRevisorRequestSuccess,
  updateAggregateBrEntRevisorRequestFailure,
  getCertificationInfoSuccessAction,
  getCertificationInfoFailureAction,
  getCampaignRevisorsSuccessAction,
  getCampaignRevisorsFailureAction,
  getTechnicalUserTabListActionSuccess,
  getTechnicalUserTabListActionFailure,
  getEntitlementsGivenTechnicalUserActionSuccess,
  getEntitlementsGivenTechnicalUserActionFailure,
  getTechnicalUsersGivenEntitlementActionSuccess,
  getTechnicalUsersGivenEntitlementActionFailure,
  updateAggregateTechnicalUserRevisorRequestSuccess,
  updateAggregateTechnicalUserRevisorRequestFailure,
  editPerimeterTechnicalUsersPerimeterRequestSuccess,
  editPerimeterTechnicalUsersPerimeterRequestFailure,
} from "./action";

import {
  certificationItemsKeep,
  certificationItemsRevoke,
  certificationItemsValidate,
  fetchCertificationRequest,
  fetchRevisorsRequest,
  fetchEditCertificationInstance,
  fetchCloseCertification,
  fetchSendCertificationReminder,
  fetchCloseCertificationItem,
  fetchUpdateRevisor,
  fetchReOpenItem,
  fetchSupervisorsAndRevisorsRequestCertificationReference,
  fetchUsersRequest,
  fetchBRRequest,
  fetchApplicationsRequest,
  fetchUserTabList,
  fetchOUTabList,
  fetchBRTabList,
  fetchEntitlementTabList,
  fetchAccountTabList,
  fetchEntitlementsGivenUser,
  fetchUsersGivenEntitlement,
  fetchEnTitlementsGivenOu,
  fetchEnTitlementsGivenBr,
  fetchAccountsGivenUser,
  fetchMassiveOperation,
  fetchUpdateAggregateOuRevisor,
  fetchUpdateAggregateUserRevisor,
  fetchUpdateAggregateBrEntRevisor,
  fetchCertificationInfo,
  fetchCampaignRevisors,
  fetchTechnicalUserTabList,
  fetchEntitlementsGivenTechnicalUser,
  fetchTechnicalUsersGivenEntitlement,
} from "./services";

import {
  fetchGroupsRequest,
  fetchEntitlementsRequest,
} from "../../CreateCertifaction/module/services";

import { ofType } from "redux-observable";
import { mergeMap, map, catchError, debounceTime } from "rxjs/operators";
import { of } from "rxjs";
import {
  IAccountsGivenUserBody,
  IEntitlementsGivenBrBody,
  IEntitlementsGivenOuBody,
  IEntitlementsGivenTechnicalUserBody,
  IEntitlementsGivenUserBody,
  IGetAccountTabListBody,
  IGetBRTabListBody,
  IGetEntitlementTabListBody,
  IGetOUTabListBody,
  IGetTechnicalUserTabListBody,
  IGetUserTabListBody,
  IUsersGivenEntitlementBody,
} from "../CertificationReferenceStepTwo/module/constants";
import { IFetchMassiveBody } from "./constants";
import { adminTechnicalUsersGetAllTU } from "../../../service/technicalUserService";

const fetchSupervisorsRequestCertificationReferenceEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SUPERVISORS_REQUEST_CERTIFICATION_REFERENCE),
    mergeMap((action: { payload: any }) =>
      fetchSupervisorsAndRevisorsRequestCertificationReference(
        action.payload
      ).pipe(
        map((response: any) =>
          supervisorsRequestCertificationReferenceSuccess(response)
        ),
        catchError((error: any) =>
          of(supervisorsRequestCertificationReferenceFailure(error))
        )
      )
    )
  );

const fetchCertificationRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CERTIFICATION_REQUEST),
    mergeMap((action: any) =>
      fetchCertificationRequest(action.payload).pipe(
        map((response: any) => certificationRequestSuccess(response)),
        catchError((error: any) => of(certificationRequestFailure(error)))
      )
    )
  );

const fetchCertificationRequestInfoEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_CAMPAIGN_INFO),
    mergeMap((action: any) =>
      fetchCertificationInfo(action.payload).pipe(
        map((response: any) => getCertificationInfoSuccessAction(response)),
        catchError((error: any) => of(getCertificationInfoFailureAction(error)))
      )
    )
  );

const fetchCampaignRevisorsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_CAMPAIGN_REVISORS),
    mergeMap((action: any) =>
      fetchCampaignRevisors(action.payload).pipe(
        map((response: any) => getCampaignRevisorsSuccessAction(response)),
        catchError((error: any) => of(getCampaignRevisorsFailureAction(error)))
      )
    )
  );

const fetchRevisorsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_EDIT_REVISOR_REQUEST),
    mergeMap((action: any) =>
      fetchRevisorsRequest(action.payload).pipe(
        map((response: any) => editRevisorRequestSuccess(response)),
        catchError((error: any) => of(editRevisorRequestFailure(error)))
      )
    )
  );

const fetchKeepItemRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.KEEP_ITEMS_REQUEST),
    mergeMap((action: any) =>
      certificationItemsKeep(action.payload).pipe(
        map((response: any) => keepItemsRequestSuccess(response)),
        catchError((error: any) => of(keepItemsRequestFailure(error)))
      )
    )
  );

const fetchRevokeItemRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.REVOKE_ITEMS_REQUEST),
    mergeMap((action: any) =>
      certificationItemsRevoke(action.payload).pipe(
        map((response: any) => revokeItemsRequestSuccess(response)),
        catchError((error: any) => of(revokeItemsRequestFailure(error)))
      )
    )
  );

const fetchValidateItemRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VALIDATE_ITEMS_REQUEST),
    mergeMap((action: any) =>
      certificationItemsValidate(action.payload).pipe(
        map((response: any) => validateItemsRequestSuccess(response)),
        catchError((error: any) => of(validateItemsRequestFailure(error)))
      )
    )
  );

const fetchEditCampaignDetailEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.EDIT_CAMPAIGN_REQUEST),
    mergeMap((action: any) =>
      fetchEditCertificationInstance(action.payload).pipe(
        map((response: any) => editCampaignRequestSuccess(response)),
        catchError((error: any) => of(editCampaignRequestFailure(error)))
      )
    )
  );

const fetchCloseCertificationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_CLOSE_CERTIFICATION),
    mergeMap((action: any) =>
      fetchCloseCertification(action.payload).pipe(
        map((response: any) => closeCertificationSuccess(response)),
        catchError((error: any) => of(closeCertificationFailure(error)))
      )
    )
  );

const fetchSendCertificationReminderEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_SEND_CERTIFICATION_REMINDER),
    mergeMap((action: any) =>
      fetchSendCertificationReminder(action.payload).pipe(
        map((response: any) => sendCertificationReminderSuccess(response)),
        catchError((error: any) => of(sendCertificationReminderFailure(error)))
      )
    )
  );

const fetchCloseCertificationItemEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_CLOSE_CERTIFICATION_ITEM),
    mergeMap((action: any) =>
      fetchCloseCertificationItem(action.payload).pipe(
        map((response: any) => closeCertificationItemSuccess(response)),
        catchError((error: any) => of(closeCertificationItemFailure(error)))
      )
    )
  );

const fetchUpdateRevisorEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_UPDATE_REVISOR),
    mergeMap((action: any) =>
      fetchUpdateRevisor(
        action.payload.itemIds,
        action.payload.revisorCode
      ).pipe(
        map((response: any) => updateRevisorSuccess(response)),
        catchError((error: any) => of(updateRevisorFailure(error)))
      )
    )
  );

const fetchUpdateAggregateOuRevisorEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_AGGREGATE_OU_REVISOR_REQUEST),
    mergeMap((action: any) =>
      fetchUpdateAggregateOuRevisor(
        action.payload.body,
        action.payload.revisorCode
      ).pipe(
        map((response: any) =>
          updateAggregateOuRevisorRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(updateAggregateOuRevisorRequestFailure(error))
        )
      )
    )
  );

const fetchUpdateAggregateUserRevisorEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_AGGREGATE_USER_REVISOR_REQUEST),
    mergeMap((action: any) =>
      fetchUpdateAggregateUserRevisor(
        action.payload.body,
        action.payload.revisorCode
      ).pipe(
        map((response: any) =>
          updateAggregateUserRevisorRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(updateAggregateUserRevisorRequestFailure(error))
        )
      )
    )
  );

const fetchUpdateAggregateTechnicalUserRevisorEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_AGGREGATE_TECH_USER_REVISOR_REQUEST),
    mergeMap((action: any) =>
      fetchUpdateAggregateUserRevisor(
        action.payload.body,
        action.payload.revisorCode
      ).pipe(
        map((response: any) =>
          updateAggregateTechnicalUserRevisorRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(updateAggregateTechnicalUserRevisorRequestFailure(error))
        )
      )
    )
  );

const fetchUpdateAggregateBrEntRevisorEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_AGGREGATE_BR_ENT_REVISOR_REQUEST),
    mergeMap((action: any) =>
      fetchUpdateAggregateBrEntRevisor(
        action.payload.body,
        action.payload.revisorCode
      ).pipe(
        map((response: any) =>
          updateAggregateBrEntRevisorRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(updateAggregateBrEntRevisorRequestFailure(error))
        )
      )
    )
  );

const fetchReOpenItemEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_REOPEN_ITEM),
    mergeMap((action: any) =>
      fetchReOpenItem(action.payload).pipe(
        map((response: any) => reOpenItemSuccess(response)),
        catchError((error: any) => of(reOpenItemFailure(error)))
      )
    )
  );

const fetchGroupsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.EDIT_PERIMETER_GROUPS_PERIMETER_REQUEST),
    mergeMap((action: { payload: any }) =>
      fetchGroupsRequest(action.payload).pipe(
        map((response: any) =>
          editPerimeterGroupsPerimeterRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(editPerimeterGroupsPerimeterRequestFailure(error))
        )
      )
    )
  );

const editPerimeterOwnershipFetchEntitlementsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.EDIT_PERIMETER_OWNERSHIP_ENTITLEMENTS_PERIMETER_REQUEST),
    mergeMap((action: { payload: any }) =>
      fetchEntitlementsRequest(action.payload).pipe(
        map((response: any) =>
          editPerimeterOwnershipEntitlementsPerimeterRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(editPerimeterOwnershipEntitlementsPerimeterRequestFailure(error))
        )
      )
    )
  );

const fetchUsersRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.EDIT_PERIMETER_USERS_PERIMETER_REQUEST),
    mergeMap((action: { payload: any }) =>
      fetchUsersRequest(action.payload).pipe(
        map((response: any) =>
          editPerimeterUsersPerimeterRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(editPerimeterUsersPerimeterRequestFailure(error))
        )
      )
    )
  );

const fetchBRRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.EDIT_PERIMETER_BR_PERIMETER_REQUEST),
    mergeMap((action: { payload: any }) =>
      fetchBRRequest(action.payload).pipe(
        map((response: any) =>
          editPerimeterBrPerimeterRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(editPerimeterBrPerimeterRequestFailure(error))
        )
      )
    )
  );

const fetchApplicationsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.EDIT_PERIMETER_APPLICATIONS_PERIMETER_REQUEST),
    mergeMap((action: { payload: any }) =>
      fetchApplicationsRequest(action.payload).pipe(
        map((response: any) =>
          editPerimeterApplicationsPerimeterRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(editPerimeterApplicationsPerimeterRequestFailure(error))
        )
      )
    )
  );

const fetchTechnicalUsersRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.EDIT_PERIMETER_TECHNICAL_USER_PERIMETER_REQUEST),
    mergeMap((action: any) =>
      adminTechnicalUsersGetAllTU().pipe(
        map((response: any) =>
          editPerimeterTechnicalUsersPerimeterRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(editPerimeterTechnicalUsersPerimeterRequestFailure(error))
        )
      )
    )
  );

const fetchUserTabListEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_USER_TAB_LIST),
    debounceTime(100),
    mergeMap((action: { payload: IGetUserTabListBody }) =>
      fetchUserTabList(action.payload).pipe(
        map((response: any) => getUserTabListActionSuccess(response)),
        catchError((error: any) => of(getUserTabListActionFailure(error)))
      )
    )
  );

const fetchOUTabListEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_OU_TAB_LIST),
    mergeMap((action: { payload: IGetOUTabListBody }) =>
      fetchOUTabList(action.payload).pipe(
        map((response: any) => getOUTabListActionSuccess(response)),
        catchError((error: any) => of(getOUTabListActionFailure(error)))
      )
    )
  );

const fetchBRTabListEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_BR_TAB_LIST),
    debounceTime(100),
    mergeMap((action: { payload: IGetBRTabListBody }) =>
      fetchBRTabList(action.payload).pipe(
        map((response: any) => getBRTabListActionSuccess(response)),
        catchError((error: any) => of(getBRTabListActionFailure(error)))
      )
    )
  );

const fetchEntitlementTabListEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ENTITLEMENT_TAB_LIST),
    debounceTime(100),
    mergeMap((action: { payload: IGetEntitlementTabListBody }) =>
      fetchEntitlementTabList(action.payload).pipe(
        map((response: any) => getEntitlementTabListActionSuccess(response)),
        catchError((error: any) =>
          of(getEntitlementTabListActionFailure(error))
        )
      )
    )
  );

const fetchAccountTabListEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ACCOUNT_TAB_LIST),
    mergeMap((action: { payload: IGetAccountTabListBody }) =>
      fetchAccountTabList(action.payload).pipe(
        map((response: any) => getAccountTabListActionSuccess(response)),
        catchError((error: any) => of(getAccountTabListActionFailure(error)))
      )
    )
  );

const fetchTechnicalUserTabListEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_TECHNICAL_USER_TAB_LIST),
    mergeMap((action: { payload: IGetTechnicalUserTabListBody }) =>
      fetchTechnicalUserTabList(action.payload).pipe(
        map((response: any) => getTechnicalUserTabListActionSuccess(response)),
        catchError((error: any) =>
          of(getTechnicalUserTabListActionFailure(error))
        )
      )
    )
  );

const fetchEntitlementsGivenUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ENTITLEMENTS_GIVEN_USER),
    mergeMap((action: { payload: IEntitlementsGivenUserBody }) =>
      fetchEntitlementsGivenUser(action.payload).pipe(
        map((response: any) => getEntitlementsGivenUserActionSuccess(response)),
        catchError((error: any) =>
          of(getEntitlementsGivenUserActionFailure(error))
        )
      )
    )
  );

const fetchUsersGivenEntitlementEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_USERS_GIVEN_ENTITLEMENT),
    mergeMap((action: { payload: IUsersGivenEntitlementBody }) =>
      fetchUsersGivenEntitlement(action.payload).pipe(
        map((response: any) => getUsersGivenEntitlementActionSuccess(response)),
        catchError((error: any) =>
          of(getUsersGivenEntitlementActionFailure(error))
        )
      )
    )
  );

const fetchEntitlementsGivenOuEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ENTITLEMENTS_GIVEN_OU),
    mergeMap((action: { payload: IEntitlementsGivenOuBody }) =>
      fetchEnTitlementsGivenOu(action.payload).pipe(
        map((response: any) => getEntitlementsGivenOuActionSuccess(response)),
        catchError((error: any) =>
          of(getEntitlementsGivenOuActionFailure(error))
        )
      )
    )
  );

const fetchEntitlementsGivenBrEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ENTITLEMENTS_GIVEN_BR),
    mergeMap((action: { payload: IEntitlementsGivenBrBody }) =>
      fetchEnTitlementsGivenBr(action.payload).pipe(
        map((response: any) => getEntitlementsGivenBrActionSuccess(response)),
        catchError((error: any) =>
          of(getEntitlementsGivenBrActionFailure(error))
        )
      )
    )
  );

const fetchAccountsGivenUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ACCOUNTS_GIVEN_USER),
    mergeMap((action: { payload: IAccountsGivenUserBody }) =>
      fetchAccountsGivenUser(action.payload).pipe(
        map((response: any) => getAccountsGivenUserActionSuccess(response)),
        catchError((error: any) => of(getAccountsGivenUserActionFailure(error)))
      )
    )
  );

const fetchEntitlementsGivenTechnicalUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ENTITLEMENTS_GIVEN_TECHNICAL_USER),
    mergeMap((action: { payload: IEntitlementsGivenTechnicalUserBody }) =>
      fetchEntitlementsGivenTechnicalUser(action.payload).pipe(
        map((response: any) =>
          getEntitlementsGivenTechnicalUserActionSuccess(response)
        ),
        catchError((error: any) =>
          of(getEntitlementsGivenTechnicalUserActionFailure(error))
        )
      )
    )
  );

const fetchTechnicalUsersGivenEntitlementEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_TECHNICAL_USERS_GIVEN_ENTITLEMENT),
    mergeMap((action: { payload: IAccountsGivenUserBody }) =>
      fetchTechnicalUsersGivenEntitlement(action.payload).pipe(
        map((response: any) =>
          getTechnicalUsersGivenEntitlementActionSuccess(response)
        ),
        catchError((error: any) =>
          of(getTechnicalUsersGivenEntitlementActionFailure(error))
        )
      )
    )
  );

const fetchMassiveOperationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.MASSIVE_OPERATIONS_ITEM_REQUEST),
    mergeMap(
      (action: {
        payload: {
          instanceId: string;
          endpoint: string;
          body: IFetchMassiveBody;
        };
      }) =>
        fetchMassiveOperation(
          action.payload.instanceId,
          action.payload.endpoint,
          action.payload.body
        ).pipe(
          map((response: any) =>
            massiveOperationsItemsRequestSuccess(response)
          ),
          catchError((error: any) =>
            of(massiveOperationsItemsRequestFailure(error))
          )
        )
    )
  );

export default [
  fetchCertificationRequestInfoEpic,
  fetchCertificationRequestsEpic,
  fetchKeepItemRequestEpic,
  fetchRevokeItemRequestEpic,
  fetchValidateItemRequestEpic,
  fetchRevisorsRequestEpic,
  fetchEditCampaignDetailEpic,
  fetchCloseCertificationEpic,
  fetchSendCertificationReminderEpic,
  fetchCloseCertificationItemEpic,
  fetchUpdateRevisorEpic,
  fetchReOpenItemEpic,
  fetchGroupsRequestEpic,
  fetchUsersRequestEpic,
  fetchBRRequestEpic,
  fetchTechnicalUsersRequestEpic,
  fetchApplicationsRequestEpic,
  fetchSupervisorsRequestCertificationReferenceEpic,
  editPerimeterOwnershipFetchEntitlementsRequestEpic,
  fetchUserTabListEpic,
  fetchOUTabListEpic,
  fetchBRTabListEpic,
  fetchEntitlementTabListEpic,
  fetchAccountTabListEpic,
  fetchTechnicalUserTabListEpic,
  fetchEntitlementsGivenUserEpic,
  fetchUsersGivenEntitlementEpic,
  fetchEntitlementsGivenOuEpic,
  fetchEntitlementsGivenBrEpic,
  fetchAccountsGivenUserEpic,
  fetchEntitlementsGivenTechnicalUserEpic,
  fetchTechnicalUsersGivenEntitlementEpic,
  fetchMassiveOperationEpic,
  fetchUpdateAggregateOuRevisorEpic,
  fetchUpdateAggregateUserRevisorEpic,
  fetchUpdateAggregateTechnicalUserRevisorEpic,
  fetchUpdateAggregateBrEntRevisorEpic,
  fetchCampaignRevisorsEpic,
];
